<template>
  <viewer
    :class="`form-element form-${type}-element text-left`"
    :initial-value="options.text"
  />
</template>

<script>
import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

export default {
  components: {
    Viewer
  },
  props: {
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  }
};
</script>
